<template>
  <span>
    {{text.slice(0,sliceTo)}}
    <span v-if="dots">....</span>
    <span v-if="text.length>200" @click="showMore" class="more ml-1">{{moreText}}</span>
  </span>
</template>

<script>
export default {
  props: {
    text: String,
    maxLength: Number
  },
  data() {
    return {
      sliceTo: this.maxLength,
      moreText: "More",
      dots: false
    };
  },
  methods: {
    showMore() {
      if (this.moreText == "More") {
        this.sliceTo = this.text.length;
        this.moreText = "Less";
        this.dots = false;
      } else {
        this.sliceTo = this.maxLength;
        this.moreText = "More";
        this.dots = true;
      }
    }
  },
  mounted() {
    if (this.text.length > this.maxLength) {
      this.dots = true;
    }
  }
};
</script>

<style>
</style>